var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("CardContainer", {
    staticClass: "h-full p-0",
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c("DefaultProjectImage", {
              staticClass: "mb-3",
              attrs: {
                title: _vm.project.client_name
                  ? _vm.project.client_name
                  : _vm.project.name,
              },
            }),
            _c("CardTitleContainer", {
              attrs: {
                title: _vm.project.client_name,
                routeParams: _vm.projectActivitiesPageRoute,
              },
            }),
            _c("div", [
              _c("p", { staticClass: "text-xs block text-gray-new" }, [
                _vm._v(_vm._s(_vm.clientId)),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }